import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchSubprocessen, initialState } from '../services/fetchSubprocessen'

import { useSubprocessenStore } from './useSubprocessenStore'

export { useSubprocessen }

const queryKey = 'hoofdleiding-dashboard-subprocessen'

const useQueryStore = () => {
  const { query, storeQuery } = useSubprocessenStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useSubprocessen = () => {
  const { onChangeFilters, onReset, query } = useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => fetchSubprocessen({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    initialFilters: initialState.query.filters,
    onChangeFilters,
    onReset,
    onRefresh: refetch,
  }
}
